import React,{useEffect} from "react";
import "./Blog_outer_tab.css";
import { getblogcategory } from "../../../../features/blog/Slice";
import { useDispatch, useSelector } from "react-redux";

function Blog_outer_tab({setSelectedCategory,selectedCategory}) {
  const blodcategory = useSelector((state) => state.blog.addBlogcategory);
  const dispatch = useDispatch();
 

  useEffect(() => {
           dispatch(getblogcategory());
         }, [dispatch]);

  return (
    <section className="Blog_outer_tab">
      <div className="categories-container">
        <h3 className="categories-title">Categories</h3>
        <ul className="categories-list">
        {blodcategory?.data?.length > 0 ? (
            blodcategory.data.map((item) => (
              <li key={item.id}  onClick={() => setSelectedCategory(item.id)} // Click event to set selectedCategory
              className={selectedCategory === item.id ? "active" : ""} // Highlight selected category
              style={{ cursor: "pointer" }}
              >
                {item.name}
                </li> // Rendering blodcategory names dynamically
            ))
          ) : (
            <li>No categories available</li>
          )}
        </ul>
      </div>
    </section>
  );
}

export default Blog_outer_tab;